(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateDeleteController',RptTemplateDeleteController);

    RptTemplateDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptTemplate'];

    function RptTemplateDeleteController($uibModalInstance, entity, RptTemplate) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptTemplate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
